var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23.768,
    viewBox: "0 0 26 23.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(0 -20.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660",
    transform: "translate(0 20.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4494",
    "data-name": "Path 4494",
    d: "M219.67,333.382a1.445,1.445,0,0,0,0,2.89,1.445,1.445,0,0,0,0-2.89Z",
    transform: "translate(-206.669 -316.852)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4495",
    "data-name": "Path 4495",
    d: "M25.367,42.32a4.563,4.563,0,0,0,.011-4.618l-8.37-14.495A4.612,4.612,0,0,0,9,23.2L.621,37.712A4.629,4.629,0,0,0,4.629,44.65H21.348A4.6,4.6,0,0,0,25.367,42.32ZM23.55,41.272a2.526,2.526,0,0,1-2.207,1.277H4.624A2.491,2.491,0,0,1,2.443,41.3a2.529,2.529,0,0,1-.005-2.549l8.38-14.506a2.517,2.517,0,0,1,4.372.005l8.375,14.506A2.5,2.5,0,0,1,23.55,41.272Z",
    transform: "translate(0 -20.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4496",
    "data-name": "Path 4496",
    d: "M218.84,157.217a1.571,1.571,0,0,0-1.115,1.578c.035.457.064.919.1,1.375.1,1.74.2,3.444.295,5.184a1.059,1.059,0,0,0,1.081,1.017,1.081,1.081,0,0,0,1.081-1.052c0-.358,0-.688.035-1.052.064-1.115.133-2.231.2-3.346.035-.722.1-1.445.133-2.167a1.784,1.784,0,0,0-.133-.722A1.448,1.448,0,0,0,218.84,157.217Z",
    transform: "translate(-206.198 -150.222)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.54d1a762a7c047ee5bc84f2f736157f0.svg";
export { ForwardRef as ReactComponent };